// Version của một pack source LOCAL (`avatar sync --local <dir>`).
//
// Tách khỏi `sync.ts` ở #211 phase-02 vì `sync --all --local` cần đúng phép đọc này để suy
// version ĐÍCH cho toàn registry — copy lại là mở đường cho 2 định nghĩa "bản local là bản
// nào" lệch nhau.
//
// ⚠️ Nguồn CÓ `.pack-version` thì trả NGUYÊN nội dung — `local-<date>` chỉ là fallback khi
// file thiếu/rỗng. Hệ quả cho `--all`: nguồn thiếu `.pack-version` ⇒ đích không parse được ⇒
// `classifyPackVersionTransition` trả `unknown` cho MỌI cặp so ⇒ 2 luật version TẮT trên toàn
// registry (kể cả nơi đang chạy beta mới hơn). Luôn `--dry-run` trước trong ca đó.
import { readFile } from "node:fs/promises";
import { join } from "node:path";

export async function readLocalPackVersion(sourceDir: string): Promise<string> {
  try {
    const raw = await readFile(join(sourceDir, ".pack-version"), "utf8");
    const v = raw.trim();
    if (v) return v;
  } catch {
    // no .pack-version → fall through to a dated local tag
  }
  return `local-${new Date().toISOString().slice(0, 10)}`;
}
